import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import { Button } from '@/_components/ui/button'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/_components/ui/form'
import { Input } from '@/_components/ui/input'

import type { StepSubmitHandler } from '../_types/step'

const emailStepValidationSchema = z.object({
  email: z
    .string({
      error: 'O e-mail é obrigatório',
    })
    .trim()
    .min(1, {
      message: 'O e-mail é obrigatório',
    })
    .email({
      message: 'Insira um e-mail válido.',
    }),
})

type EmailStepValidationSchema = z.infer<typeof emailStepValidationSchema>

export type EmailStepSubmitHandler = StepSubmitHandler<EmailStepValidationSchema>

export interface EmailStepProps {
  onSubmit: EmailStepSubmitHandler
  defaultEmailValue?: string
}

export const EmailStep = ({ onSubmit, defaultEmailValue }: EmailStepProps) => {
  const form = useForm<EmailStepValidationSchema>({
    resolver: zodResolver(emailStepValidationSchema),
    defaultValues: {
      email: defaultEmailValue ?? '',
    },
  })

  return (
    <Form {...form}>
      <form
        className="space-y-6"
        onSubmit={form.handleSubmit((data) => onSubmit(data, form.setError))}
      >
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Email</FormLabel>
              <FormControl>
                <Input placeholder="Insira seu e-mail cadastrado" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <Button type="submit" className="w-full" disabled={form.formState.isSubmitting}>
          Enviar
        </Button>
      </form>
    </Form>
  )
}
